import { Injectable } from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {ErrorInfos} from './error-infos';
import {NotificationToastService} from '../services/notifications/notification-toast.service';
import {ToastErrorModel} from '../models/toasts/toast-error.model';

@Injectable({
  providedIn: 'root'
})
export class Other404ErrorInterceptorService implements HttpInterceptor{

  constructor(private notificationToastService: NotificationToastService) { }

  private static isOther404Error(err: HttpErrorResponse): boolean {
    return err.status == 404 && (err.error == null || err.error['messageError'] == null);
  }

  private extractInfos(err: HttpErrorResponse): Observable<any> {
    return new Observable(observer => {
      if (Other404ErrorInterceptorService.isOther404Error(err)) {
        observer.error(new ErrorInfos(`Ressource non trouvée`, err.url))
      } else {
        observer.error(null)
      }
    });
  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((erreurBrute: HttpErrorResponse) => {
        return this.extractInfos(erreurBrute).pipe(
          catchError((erreurDecodee: ErrorInfos) => {
            if (erreurDecodee != null) {
              this.notificationToastService.push(new ToastErrorModel(erreurDecodee.content, erreurDecodee.title));
            }
            return throwError(erreurBrute);
          }),
        ) }
      ),
    );
  }
}
